<template>
  <Modal id="add-new-account" :title="title" class="create-carrier-account-form" @submit="submit">
    <template v-slot:body>
      <div class="position-relative row general">
        <div class="col-6 col-xl-4 mt-2 mb-2" v-for="(object, key) in platforms" :key="key">
          <input type="radio" :value="key" v-model="platform" />
          <div :class="`card modal-item ${key}`">
            <img :src="`/assets/images/${object.logo}`" />
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  data() {
    return {
      platform: ''
    }
  },
  computed: {
    title() {
      return 'Create Carrier Account'
    },
    action() {
      return 'create'
    },
    submitUri() {
      return `carrier-account/create`
    },
    platforms() {
      let allPlatforms = Object.assign({}, this.$util.options.platforms)
      let platforms = {}
      for (const [key, object] of Object.entries(allPlatforms)) {
        if (object.is_carrier && object.enabled) {
          platforms[key] = object
        }
      }
      return platforms
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    submit() {
      this.submitForm(
        {
          platform: this.platform
        },
        {
          done: (response) => {
            if (!_.isUndefined(response.id)) {
              this.$emitter.emit('Modal', {
                name: 'carrier-account.edit',
                data: {
                  _id: response.id,
                  _platform: this.platform
                },
                $el: this.$el
              })
            }
          }
        }
      )
    }
  },
  props: {
    config: Object
  }
}
</script>
